import { SHAME_LOGIC_URL } from '../lib/legal'
import { openExternalLink } from '../lib/openExternal'
import { LegalLinks } from './LegalLinks'

type Props = {
  onPrivacy: () => void
  onTerms: () => void
}

export function LegalFooter({ onPrivacy, onTerms }: Props) {
  const linkClass = 'text-xs text-foam-faint underline-offset-2 hover:text-whiskey-light hover:underline'

  return (
    <footer className="mt-2 space-y-2">
      <LegalLinks onPrivacy={onPrivacy} onTerms={onTerms} />
      <p className="text-center text-[11px] text-foam-faint/80">
        Free. No subscriptions. House ads only.{' '}
        <a
          className={linkClass}
          href={SHAME_LOGIC_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(event) => openExternalLink(event, SHAME_LOGIC_URL)}
        >
          Shame Logic LLC
        </a>
      </p>
    </footer>
  )
}
